__turbopack_context__.v({
  "footer": "LoyaltySlideContent-module-scss-module__Jk7VCq__footer",
  "header": "LoyaltySlideContent-module-scss-module__Jk7VCq__header",
  "value": "LoyaltySlideContent-module-scss-module__Jk7VCq__value",
});
